const shouldLog = () => !!document.querySelector("body.woocommerce-cart");

const cartRedesign = {
	context: {},
	tests: [
		{
			run: () => {
				// probably nothing because it is the default
			},
			shouldLog,
			weight: 5,
			description: "Default situation",
		},
		{
			run: () => {
				// your ab test code here
			},
			shouldLog,
			weight: 5,
			description: "Cart Redesign",
		},
	],
	canBeEnabled: () => {
		// return window.location.hostname.includes("dev");
		// return false;
		return true;
	},
};

export default cartRedesign;
